import { render, staticRenderFns } from "./goodsWriteBlackList.vue?vue&type=template&id=2d7af001&scoped=true&"
import script from "./goodsWriteBlackList.vue?vue&type=script&lang=js&"
export * from "./goodsWriteBlackList.vue?vue&type=script&lang=js&"
import style0 from "./goodsWriteBlackList.vue?vue&type=style&index=0&id=2d7af001&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7af001",
  null
  
)

component.options.__file = "goodsWriteBlackList.vue"
export default component.exports